module.exports = __webpack_public_path__ + "img/editor-footer.6d885d14.svg";